import { render, staticRenderFns } from "./conProjectAdd.vue?vue&type=template&id=a906ffac&scoped=true&"
import script from "./conProjectAdd.vue?vue&type=script&lang=js&"
export * from "./conProjectAdd.vue?vue&type=script&lang=js&"
import style0 from "./conProjectAdd.vue?vue&type=style&index=0&id=a906ffac&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a906ffac",
  null
  
)

export default component.exports